import { Moment } from 'moment'
import React, { FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Person } from '../../../App/store/features/person/IPerson'
import { TextArea } from '../../../Common/TextInput'
import { IBlockedCategory } from '../../types'
// import {
//   UserPicker,
//   AppointmentDateRangePicker,
//   HourPicker,
//   AppointmentRecurrence,
// } from '../Inputs'
import { CategorySelect } from '../Inputs/CategorySelect'

import { BlockedCategorySelectWrapper } from './style'

interface IProps {
  persons: Person[]
  appointmentMoment: Moment
  setValue: UseFormSetValue<any>
  watchIsRepeat: boolean
  watchRepeatOption: any
  blockCategories: IBlockedCategory[]
}

export const BlockFormFields: FunctionComponent<IProps> = ({
  blockCategories,
  persons,
  appointmentMoment,
  setValue,
  watchIsRepeat,
  watchRepeatOption,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <BlockedCategorySelectWrapper>
        <CategorySelect
          setValue={setValue}
          blockedCategoryOptions={blockCategories}
        />
      </BlockedCategorySelectWrapper>
      {/* <UserPicker persons={persons} setValue={setValue} />*/}
      {/* <AppointmentDateRangePicker*/}
      {/*  setValue={setValue}*/}
      {/*  appointmentMoment={appointmentMoment}*/}
      {/*/ >*/}
      {/* <HourPicker*/}
      {/*  appointmentMoment={appointmentMoment}*/}
      {/*  setValue={setValue}*/}
      {/*  inputName="startHour"*/}
      {/*/ >*/}
      {/* <HourPicker*/}
      {/*  appointmentMoment={appointmentMoment.clone().add(60, 'm')}*/}
      {/*  setValue={setValue}*/}
      {/*  inputName="endHour"*/}
      {/*  labelName={t('End time')}*/}
      {/*/ >*/}

      {/* <AppointmentRecurrence*/}
      {/*  setValue={setValue}*/}
      {/*  watchIsRepeat={watchIsRepeat}*/}
      {/*  watchRepeatOption={watchRepeatOption}*/}
      {/*/ >*/}

      <label htmlFor="notes">
        <span>{t('Block note')}</span>
        <TextArea
          onChange={e => setValue('notes', e.target.value)}
          width={400}
        />
      </label>
    </>
  )
}
